import { render, staticRenderFns } from "./supplier-offer.vue?vue&type=template&id=77ece5d6&"
import script from "./supplier-offer.vue?vue&type=script&setup=true&lang=js&"
export * from "./supplier-offer.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports